<template>
    <div class="clearfix">
        <div class="alert alert-danger p-4 text-dark" style="display: inline-table;" >
            <h5><span class="mdi mdi-information-outline text-danger"></span> {{ t('clientsDeletion-deletion_info-irreversible') }}</h5>
            {{ t('clientsDeletion-deletion_info-will_delete') }}

            <ul>
                <li> {{ t('clientsDeletion-deletion_info-all_sales') }}</li>
                <li> {{ t('clientsDeletion-deletion_info-all_tasks') }}</li>
                <li> {{ t('clientsDeletion-deletion_info-all_messages') }}</li>
                <li>{{ t('clientsDeletion-deletion_info-all_records') }}</li>
            </ul>

            <strong> {{ t('clientsDeletion-deletion_info-permanent') }} </strong>

            <strong class="text-danger"> {{ t('clientsDeletion-deletion_info-inconsistency') }}</strong>{{ t('clientsDeletion-deletion_info-inconsistency_detail') }}

        </div>
    </div>
</template>

<script>
export default {
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
